var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchBar',{attrs:{"placeholder":_vm.$t('modules.positions.topbar.searchLabel'),"hasResults":_vm.hasResults},on:{"queryChange":_vm.setQuery}},[_vm._v("\n    "+_vm._s()+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }